import {
  SHOW_SUCCESS_NOTIFICATION,
  HIDE_SUCCESS_NOTIFICATION,
  IS_GET_QUESTIONS_INPROGRESS,
  IS_SUBMIT_INPROGRESS,
  IS_SURVEY_ENABLED,
  IS_SURVEY_SUBMITTED,
  SHOW_FAILURE_NOTIFICATION,
} from './type';

export const showSuccessNotification = () => ({
  type: SHOW_SUCCESS_NOTIFICATION,
});

export const hideSuccessNotification = () => ({
  type: HIDE_SUCCESS_NOTIFICATION,
});

export const showFailureNotification = () => ({
  type: SHOW_FAILURE_NOTIFICATION,
});

export const isSubmitInProgress = (payload) => ({
  type: IS_SUBMIT_INPROGRESS,
  payload,
});

export const isSuverySubmitted = (payload) => ({
  type: IS_SURVEY_SUBMITTED,
  payload,
});

export const isGetQuestionsInProgress = (payload) => ({
  type: IS_GET_QUESTIONS_INPROGRESS,
  payload,
});

export const isSurveyEnabled = (payload) => ({
  type: IS_SURVEY_ENABLED,
  payload,
});
